import Cache from 'c-cache';

const cache = new Cache({
    prefix: 'pcuplive'
});

let UP = window['UP'] || (window['UP'] = {});

let isIE76 = !'0' [0]; // 根据：IE67对字符串进行取值需要使用charAt()方法，不能直接通过数组方式的坐标访问
let isIE6 = isIE76 && !window.XMLHttpRequest;
let isIE = !!window.ActiveXObject;
let IS_INIT = false; // 是否已经初始化
let PY_HOST = 'https://web.upliveapps.com';

let SYSTEM_LANGUAGE = (function() {
    let systemLanguage = navigator.language || navigator.browserLanguage;

    let _systemLanguage = systemLanguage.toLowerCase();


    if (_systemLanguage == 'ar') {
        systemLanguage = 'ar-EG';
    } else if (_systemLanguage == 'vi') {
        systemLanguage = 'vi-VN';
    } else if (_systemLanguage == 'en') {
        systemLanguage = 'en-US';
    } else if (_systemLanguage == 'ja') {
        systemLanguage = 'ja-JP';
    } else if(_systemLanguage == 'zh'){
        systemLanguage = 'zh-CN';
    }

    let arr = systemLanguage.split('-');

    if (arr.length > 1) {
        systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
    } else {
        systemLanguage = 'en-US';
    }

    return systemLanguage;
})();

// css3动画性能解决方案
(function() {
    var vendors = ['webkit', 'moz'];

    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
        var vp = vendors[i];
        window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = (window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame']);
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
        ||
        !window.requestAnimationFrame || !window.cancelAnimationFrame) {
        var lastTime = 0;
        window.requestAnimationFrame = function(callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function() { callback(lastTime = nextTime); },
                nextTime - now);
        };
        window.cancelAnimationFrame = clearTimeout;
    }
}());

$.getScript = function(url, options) {

    var script = document.createElement('script'),
        isFunction = $.isFunction(options),
        timer;

    // 清除定时器
    function clearTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    // success
    if (isFunction || (options && options.success)) {
        script.onload = function() {
            clearTimer();
            isFunction ? options() : options.success.call(options.context);
        };
    }

    if (!isFunction && options) {
        // failure
        if (options.error) {
            script.onerror = function() {
                clearTimer();
                options.error.call(options.context);
            }
        }
        // timeout
        if (options.timeout) {
            timer = setTimeout(function() {
                timer = null;
                if (options.error) {
                    options.error.call(options.context);
                }
            }, options.timeout);
        }
    }

    script.setAttribute('data-path', url);

    script.src = url;

    return document.body.appendChild(script);

};

let domain = document.domain;
let IS_CN = domain == 'www.upliveapp.com' || domain == 'upliveapp.com' || location.href.indexOf('__cnenv__') !== -1 ; // 国内版
let IS_MSL = domain == 'www.uplive.club' || domain == 'uplive.club' || location.href.indexOf('__arenv__') !== -1; // 中东版
let IS_External = domain == 'up.live' || domain == 'www.up.live';

let isSupportFlash = (function() {
    var hasFlash = 0;
    if (document.all) {
        var swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
        if (swf) {
            hasFlash = 1;
        }
    } else if (navigator.plugins && navigator.plugins.length > 0) {
        var swf = navigator.plugins["Shockwave Flash"];
        if (swf) {
            hasFlash = 1;
        }
    }
    return !!hasFlash;
})();

const SUPPORT_LANGUAGE = ['zh-CN', 'zh-TW', 'zh-HK', 'en-US', 'ja-JP', 'vi-VN', 'ar-EG', 'ko-KR', 'ms-MY', 'th-TH', 'fr-FR', 'pt-PT', 'ru-RU', 'id-ID', 'tr-TR','es-ES'];

// 用于处理默认网站语言码 => zh-TW
const tws = ['zh-SG', 'zh-MO', 'zh-TW'];
// 用于处理默认网站语言码 => ar-EG
const ars = ['ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SY', 'ar-TN', 'ar-YE'];
// 中东地区国家码
const middelEastCountryCodes = ['EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PK', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'UG', 'YE'];
// 国内地区国家码
const chinaCountryCodes = ['CN'];
/**
 * 全局API
 */
UP.Global = {
    version: 'CN', //CN：国内，AR：中东；All：其他

    // 语言列表
    languageList: SUPPORT_LANGUAGE,

    middelEastCountryCodes: middelEastCountryCodes,

    // 系统语言
    systemLanguage: SYSTEM_LANGUAGE,
    // 网站语言
    siteLanguage: '',

    isEdge: /Edge/i.test(navigator.userAgent), // 12+

    isIE:  /(MSIE|Trident|Edge)/.test(navigator.userAgent),
    
    isFireFox:  /(Firefox)/.test(navigator.userAgent),
    
    isSafari:  /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    
    isChrome :  /Chrome/.test(navigator.userAgent),

    videoInfo: null,
    isLoginPop: false,/*在global中储存登录弹框显示隐藏状态**/

    init() {
        // 防止重复初始化
        if (IS_INIT) return;

        IS_INIT = true;

        this.chooseLanguage();

        this.adsCountry = this.query('adscountry');
        this.initVersion();
        

        let clientType = this.query('clientType') || '';

        this.marketChannel = clientType.replace('pcuplive', '');
        this.channel = ('pc' + this.marketChannel).substring(0, 20);
    },

    initVersion() {
        let country = this.adsCountry || '';

        if (IS_CN || country == 'CN') {
            this.version = 'CN';
        } else if (IS_MSL) {
            this.version = 'AR';
        } else {
            if (middelEastCountryCodes.indexOf(country) > -1) {
                this.version = 'AR';
            } else {
                this.version = 'All';
            }
        }
    },

    initLanguage() {
        // let lang = Cookie.getCookie('_u_language');
        let lang = cache.getCache('_u_language');

        if (!lang) {
            let systemLanguage = this.systemLanguage;

            if (SUPPORT_LANGUAGE.indexOf(systemLanguage) > -1) {
                lang = systemLanguage;
            } else if (tws.indexOf(systemLanguage) > -1) {
                lang = 'zh-TW';
            } else if (ars.indexOf(systemLanguage) > -1) {
                lang = 'ar-EG';
            } else {
                lang = 'en-US';
            }

            if (IS_MSL) {
                lang = 'ar-EG';
            }
        }

        return lang;
    },

    getDefaultUA(){
        let UserAgent = 'PC/' + this.channel + ' version/8.8.8';

        if (window.smDeviceId) {
            UserAgent += ' smd/' + window.smDeviceId;
        }

        return UserAgent;
    },

    chooseLanguage(lang) {
        if (!lang) {
            lang = this.initLanguage();
        }

        $('html').attr('lang', lang);
        $('body').attr('class', '');
        $('body').addClass(lang);

        cache.setCache('_u_language', lang)
        // Cookie.setCookie('_u_language', lang);
        this.siteLanguage = lang;
    },

    isMobile() {
        var ua = navigator.userAgent;
        return !!ua.match(/AppleWebKit.*Mobile.*/) || "ontouchstart" in document.documentElement;
    },

    writeUserInfo(user) {
        
        this.cacheUserToken(user.userToken);
        this.cacheUserId(user.uid);
        
        if (cache.getCache('isRegisterRealUser')) {
            user.userToken = cache.getCache('_u_usertoken');
            cache.setCache('user', {
                userToken: user.userToken,
                uid: user.uid,
                avatar: user.avatar,
                gender: user.gender,
                grade: user.grade,
                username: user.username,
                upliveCode: user.upliveCode,
                countryCode: user.countryCode,
            }, 8 * 3600 * 1000);    
        }

        this.loginUserProfile = user;
    },

    clearUserInfo() {
        cache.removeCache('_u_uid');
        cache.removeCache('_u_usertoken');
        // UP.Cookie.delCookie('_u_uid');
        // UP.Cookie.delCookie('_u_usertoken');
        cache.removeCache('isRegisterRealUser');
        cache.removeCache('user')
        this.loginUserProfile = null;
    },

    getHotCountryCode(){
        let countryCode;

        switch (this.version) {
            case 'CN':
                countryCode = 'CN';
                break;
            case 'AR':
                countryCode = 'MA';
                break;
            default:
                countryCode = this.getUser().countryCode;
        }

        if (this.adsCountry  && this.adsCountry !== countryCode) {
            // URL上的国家码优先
            countryCode = this.adsCountry;
        }

        return countryCode;
    },
    /**
     *  获取当前用户信息
     */
    getUser() {
        return this.loginUserProfile || {};
    },

    updateUserInfo(key, value) {
        this.loginUserProfile[key] = value;
    },

    updateDiamondBanlance(diamond, bill) {
        if (diamond) {
            this.loginUserProfile.balance.diamond = parseInt(diamond, 10);
        }

        if (bill) {
            this.loginUserProfile.balance.bill = parseInt(bill, 10);
        }
    },

    getUserId() {
        // if (this.isLogin()) {
        //     return this.getUser().uid;
        // } else {
            return this.getUserIdFromCookie();
        // }
    },

    isVip() {
        let user = this.getUser() || {};
        let vipLabel;
        
        $.each(user.userLabels || [], (index, item)=>{
            if (item.label.indexOf('VIP') > -1) {
                vipLabel = item;
                return false;
            }
        });

        return vipLabel;
    },

    getUserToken() {
        let usertoken = this.getUserTokemFromCookie();

        if (!usertoken) {
            this.clearUserInfo();
        }   
        return  usertoken;
    },

    cacheUserToken(userToken) {
        // userToken && Cookie.setCookie('_u_usertoken', userToken);
        userToken && cache.setCache('_u_usertoken', userToken, 8 * 3600 * 1000); // 有效期8小时
    },

    cacheUserId(uid) {
        // uid && Cookie.setCookie('_u_uid', uid);
        uid && cache.setCache('_u_uid', uid);
    },

    getUserIdFromCookie() {
        // return Cookie.getCookie('_u_uid') || '';
        return cache.getCache('_u_uid') || '';
    },

    getHighLevelText() {
        let user = this.getUser();
        let setting = JSON.parse(user.setting) || {};

        return setting.highLevelText;
    },

    getUserTokemFromCookie() {
        // return Cookie.getCookie('_u_usertoken') || '';
        return cache.getCache('_u_usertoken') || '';
    },

    getUserCountryCode() {
        let user = this.getUser();

        if (user.uid) {
            return user.countryCode;
        } else {
            return '';
        }
    },
    /**
     * 判断用户是否登录
     */
    isLogin() {
        return !!this.getUser().uid;
    },

    isRegisterRealUser() {
        return cache.getCache('isRegisterRealUser');
    },

    query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },
    /**
     * 获取平台信息
     */
    getPlatform() {
        let [ua, pl] = [navigator.userAgent, 'other'];

        if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive') {
            pl = 'uplive';
        } else if (ua.match(/micromessenger/i)) {
            pl = 'wechat';
        } else if (ua.match(/qq/i)) {
            pl = 'qq';
        } else if (ua.match(/weibo/i)) {
            pl = 'weibo';
        } else if (ua.match(/renren/i)) {
            pl = 'renren';
        } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
            pl = 'fb';
        } else if (ua.match(/[Tt]witter/i)) {
            pl = 'twitter';
        }

        return pl;
    },
    /**
     * 获得当前系统类型
     */
    getSystem() {
        let ua = navigator.userAgent;
        let ret = /(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc';

        return ret;
    },
    /**
     * 获取python 服务器域名
     */
    getPyHost() {
        return PY_HOST;
    },

    getH5Host() {
        let url;

        if (this.version == 'CN') {
            url = '//h5.upliveapp.com';
        } else {
            url = '//m.upliveapps.com';
        }

        return url;
    },

    getH5ActHost() {
        let url;

        if (this.version == 'CN') {
            url = '//h5act.upliveapp.com';
        } else {
            url = '//mact.upliveapps.com';
        }

        return url;
    },

    ie10AndOlder(){
        if (document.all) {
            return true;
        } else {
            return false;
        }
    },
    /**横屏礼物特效设置*/
    setLandscapePingbiAnimType(val){

        cache.setItem('landscape_pinbi_anim',val,24*60*60);
        this.landscapePingBiAnimType = val;
        $.channel.emit('updatePingBiAnim');
    },
    getLandscapePingbiAnimType(){
        if(!this.landscapePingBiAnimType){
            this.landscapePingBiAnimType = cache.getItem('landscape_pinbi_anim');
        }
        if(!this.landscapePingBiAnimType){
            this.landscapePingBiAnimType = {
                broadcast: false,
                smallAnim: false,
                intoAnim: false,
                allAnim: false
            }
        }
        return this.landscapePingBiAnimType;
    }
};


UP.PrepaireForAsync = (function() {
    const replaceMessage = Math.random() + '';
    const WatingContent = `
        <html>
          <head>
                <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=1"/>
          </head>
          <style type="text/css">
            html, body{
                background-color: rgba(255,255,255,0.5);
            }
            .mini-loading {
                text-align: center;
                font-size: 20px;
                padding: 100px 0;
            }

            .mini-loading i {
                display: inline-block;
                width: 32px;
                height: 32px;
                font-style: normal;
                background: url(//g.cdn.pengpengla.com/oauthgame/html5/20170614/93eb40b5793f26377ff2bc2eff3c5f03.gif) no-repeat;
                vertical-align: middle;
                margin: 0 5px;
            }

            .mini-loading.loading-vertical i {
                display: block;
                margin: 10px auto;
            }

            .mini-loading .txt {
                display: inline-block;
                padding: 6px 0 0 5px;
            }
          </style>
          <body>
            <div class='root'>
              <div>
                <div class="mini-loading">
                    <i></i>
                    <span class="loading-tip">${replaceMessage}</span>
                </div>
              </div>
            </div>
          </body>
        </html>
        `;

    const WindowOpen = window.open;

    return function({ width = 780, height = 500, message = 'Please wait a sec...' } = {}) {
        var { outerWidth, outerHeight, screenLeft, screenTop } = window
        var left = outerWidth / 2 - width / 2 + (screenLeft || screenX)
        var top = outerHeight / 2 - height / 2 + (screenTop || screenY)

        var newWindow = WindowOpen.bind(window)('', '', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`)

        newWindow.document.write(WatingContent.replace(replaceMessage, message))

        window.open = function(url) {
            newWindow.location.replace(url)
            window.open = WindowOpen
            return newWindow
        }
        return newWindow
    }
})();

UP.WaitForRecieveMsg = (function() {
    return function(openerWindow, tag, fromtype) {
        const __privateOnMessage = window.__privateOnMessage;
        const defer = $.Deferred();

        const removeListener = function() {
            openerWindow.close();
            $(window).off('message', onMessage);
            window.__privateOnMessage = __privateOnMessage;
            window.clearInterval(interval);
        }

        const onMessage = function(event) {
            // console.log('onMessage');
            try {
                var { data, type, error } = JSON.parse(event.data || '{}') || {}
                // console.log(data, type, error);
                if (type == tag) {
                    if (error)
                        return defer.reject(error);
                    defer.resolve(data);
                    removeListener();
                }
            } catch (error) {
                console.error({ error, data: event.data });
            }
        }

        window.__privateOnMessage = (e) => {
            setTimeout(__privateOnMessage, 0, e);
            onMessage(e);
        };

        const interval = window.setInterval(function() {
            if (!openerWindow || openerWindow.closed) {
                removeListener();
                defer.reject(null);
            }
        }, 500);

        // 超时处理
        if (fromtype == 'fb') {
            setTimeout(() => {
                if (openerWindow && !openerWindow.closed) {
                    removeListener();
                    defer.reject(null);
                }
            }, 120 * 1000); // 60秒
        }


        $(window).on('message', onMessage, false)

        return defer;
    }
})();

/*--------工具---------*/

const Cookie = {
    /**
     * 判断浏览器是否能使用cookie
     * @method isCookieEnable
     * @public
     * @static
     * @return {Boolean} ret
     */
    isCookieEnable: function() {
        if (!window.navigator.cookieEnabled) {
            return false;
        }
        var key = '_test_cookie_';

        this.setCookie(key, '1');

        var v = this.getCookie(key);

        if (v === '1') {
            this.delCookie(key);
            return true;
        }
        return false;
    },

    getCookieVal: function(offset) {
        var endstr = document.cookie.indexOf(";", offset);
        if (endstr === -1) {
            endstr = document.cookie.length;
        }
        return window.unescape(decodeURIComponent(document.cookie.substring(offset, endstr)));
    },
    /**
     * 获取 Cookie
     */
    getCookie: function(name) {
        var arg = name + "=",
            alen = arg.length,
            clen = document.cookie.length,
            i = 0,
            j;

        while (i < clen) {
            j = i + alen;
            if (document.cookie.substring(i, j) === arg) {
                return this.getCookieVal(j);
            }
            i = document.cookie.indexOf(" ", i) + 1;
            if (i === 0) {
                break;
            }
        }

        return '';
    },
    /**
     * 设置cookie
     * @param name
     * @param val
     * @param expires
     */
    setCookie: function(key, value, expires) {
        var host = window.location.host,
            expires = (arguments.length > 2) ? arguments[2] : null,
            expdate = new Date();

        if (expires == null) {
            document.cookie = key + "=" + window.escape(value) + ";path=/;domain=" + host;
        } else {
            expdate.setTime(expdate.getTime() + (expires * 1000));
            document.cookie = key + "=" + window.escape(value) + ";path=/;domain=" + host + ";expires=" + expdate.toGMTString();
        }

    },

    /**
     * 删除cookie
     * @method delCookie
     * @public
     * @static
     * @param {String} name cookie名
     */
    delCookie: function(name) {
        var host = window.location.host,
            exp = new Date();

        exp.setTime(exp.getTime() - 86400 * 1000);
        document.cookie = name + '=;path=/;domain=' + host + ';expires=' + exp.toGMTString();
    }
}


window.emojione.textToEmoji = function(string) {
    const emojiTemplate = '<img alt="{alt}" class="emojione" src="{img}" />';
    
    if (UP.Global.isIE) {
        return window.emojione.shortnameToImage(window.emojione.toShort(string));
    }

    var jsEscapeMap = emojione.jsEscapeMap;

    var arrayString = [...string];
    var list = [];
    var length = arrayString.length;
    var tmpString = '';

    for (let i = 0; i < length; i++) {
        let s = arrayString[i];
        let c = jsEscapeMap[s];

        if (c) {
            tmpString && list.push(tmpString) && (tmpString = "");
            let tpl = emojiTemplate
                .replace('{alt}', s)
                .replace('{img}', 'https://cdn.jsdelivr.net/emojione/assets/3.1/png/32/' + c + '.png"');

            list.push(tpl);
        } else {
            tmpString += s;
        }
    }

    tmpString && list.push(tmpString) && (tmpString = "");

    return list.join('')
};

UP.isSupportFlash = isSupportFlash;
UP.Cookie = Cookie;
UP.Global.init();


// WEBPACK FOOTER //
// ./js/base/global.js